import styles from './ServiceHoursModal.module.scss';

import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { StartEnd } from 'olo-service';
import { toDateTime } from 'hooks/context/merchant/util';

const DAY: Record<string, number> = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

const isActive = (day: string) => {
  if (!day) return false;

  return new Date().getDay() === DAY[day];
};

type ServiceHourDayProps = {
  day: string;
  hours?: StartEnd[];
  timezone: string;
};

export const ServiceHourDay: React.FC<ServiceHourDayProps> = ({ day, hours, timezone }) => {
  const { t } = useTranslation();

  return (
    <div key={`${day}`} className={clsx(styles.dayRow, { [styles.isActive]: isActive(day) })}>
      <dt className={styles.capitalize}>
        {t(`days.${day}`)}
      </dt>
      <dd className={styles.hourRow}>
        {!hours?.length && t('closed')}
        {!!hours?.length && (
          <ul>
            {hours?.map((hour, i) => (
              <li key={`${hour.start}_${hour.end}_${i}`}>
                {t('hours', {
                  startTime: toDateTime(hour.start, timezone),
                  endTime: toDateTime(hour.end, timezone),
                })}
              </li>
            ))}
          </ul>
        )}
      </dd>
    </div>
  );
};
